import { render, staticRenderFns } from "./CallStartButton.vue?vue&type=template&id=1922ee6a"
import script from "./CallStartButton.vue?vue&type=script&lang=js"
export * from "./CallStartButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports